/*
 * Public API Surface of microapp-vms
 */

export * from './lib/microapp-vms.service';
export * from './lib/microapp-vms.module'; 
export * from './pages/microapp-vms-home.component';
export * from './pages/microapp-vms-home.module';
